import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

import { rem } from '../themeUtils';

const dataWidgetSlotRecipe = defineSlotRecipe({
  className: 'data-widget',
  slots: ['root', 'title', 'items', 'action'] as const,
  base: {
    root: {
      alignItems: 'stretch',
      background: 'background/primary',
      border: '1px solid',
      borderColor: 'border/regular',
      borderRadius: '8',
      boxShadow: 'elevation/sm',
      boxSizing: 'border-box',
      display: 'inline-flex',
      height: '40',
      paddingInlineEnd: rem(7),
    },
    title: {
      alignItems: 'center',
      background: 'background/secondary',
      borderEndStartRadius: rem(7),
      borderStartStartRadius: rem(7),
      color: 'text/primary',
      display: 'inline-flex',
      gap: '4',
      paddingInlineEnd: '12',
      paddingInlineStart: rem(15),
      textStyle: 'body/md/semibold',
    },
    items: {
      alignItems: 'center',
      display: 'inline-flex',
      flex: '1',
      gap: '4',
      paddingInlineEnd: '12',
      paddingInlineStart: '16',
      '&:first-child': {
        paddingInlineStart: rem(15),
      },
      '& > *:not(:last-child)::after': {
        alignItems: 'center',
        color: 'text/tertiary',
        content: '"•"',
        display: 'inline-flex',
        height: '16',
        justifyContent: 'center',
        marginInlineStart: '-4',
        width: '16',
      },
    },
    action: {
      alignItems: 'center',
      display: 'inline-flex',
    },
  },
});

export default dataWidgetSlotRecipe;
